import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import api from "../../services/api";

const FlavorsPage = () => {
  const [flavors, setFlavors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState("all");

  useEffect(() => {
    document.title = "Our Cake Flavors";
    fetchFlavors();
  }, []);

  const fetchFlavors = async () => {
    try {
      const res = await api.get("/flavors");
      const sorted = [...res.data].sort((a, b) => a.name.localeCompare(b.name));
      setFlavors(sorted);
    } catch (err) {
      console.error("Failed to fetch flavors", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredFlavors = flavors.filter((flavor) => {
    if (filterType === "wedding") return flavor.isSuitableForWeddings;
    if (filterType === "specialty")
      return flavor.category?.includes("specialtyCake");
    return true;
  });

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Our Cake Flavors
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        All of our specialty cakes can be made in the flavors listed below. If
        you're not sure what to pick, feel free to ask us for recommendations
        based on your preferences!
      </Typography>

      <Box sx={{ mb: 4 }}>
        <ToggleButtonGroup
          value={filterType}
          exclusive
          onChange={(e, val) => val && setFilterType(val)}
          color="primary"
          size="small">
          <ToggleButton value="all">All Flavors</ToggleButton>
          <ToggleButton value="specialty">Specialty Cake Flavors</ToggleButton>
          <ToggleButton value="wedding">Wedding Compatible</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {loading ? (
        <Box sx={{ textAlign: "center", mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {filteredFlavors.map((flavor) => (
            <Grid item xs={12} sm={6} md={4} key={flavor._id}>
              <Card
                elevation={2}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  backgroundColor: "#fefefe",
                }}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 1,
                      mb: 1,
                    }}>
                    <Typography variant="h6" fontWeight="bold">
                      {flavor.displayName}
                    </Typography>

                    {flavor.isSuitableForWeddings && (
                      <Chip
                        label="Wedding Compatible"
                        size="small"
                        sx={{
                          backgroundColor: "#c8e6c9",
                          color: "#2e7d32",
                          fontWeight: 600,
                        }}
                      />
                    )}
                  </Box>

                  {flavor.description && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1 }}>
                      {flavor.description}
                    </Typography>
                  )}

                  {flavor.icing?.name && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2 }}>
                      <strong>Icing:</strong> {flavor.icing.name}
                    </Typography>
                  )}

                  {Array.isArray(flavor.dietaryTags) &&
                    flavor.dietaryTags.length > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          mt: 1,
                        }}>
                        {flavor.dietaryTags.map((tag) => (
                          <Chip
                            key={tag._id || tag.label}
                            label={tag.label}
                            size="small"
                            sx={{
                              backgroundColor: `#${tag.color || "ccc"}`,
                              color: "#fff",
                              fontWeight: 500,
                              fontSize: "0.75rem",
                            }}
                          />
                        ))}
                      </Box>
                    )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default FlavorsPage;
